import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex items-center flex-wrap gap-1 text-sm text-foreground-500 mb-4">
      <Link to="/" className="cursor-pointer hover:text-primary-700 transition-colors">
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1">
          <span className="w-4 h-4 flex items-center justify-center text-foreground-300">
            <i className="ri-arrow-right-s-line text-base" />
          </span>
          {item.path ? (
            <Link to={item.path} className="cursor-pointer hover:text-primary-700 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}